import React from 'react'
import { graphql } from 'gatsby'
import Layout from "../components/layout"
import SEO from "../components/seo"
import SpeechDetail from "../components/speech-detail"
import Programma from "../components/programma"
// import Newsletter from "../components/newsletter"
// import Banner from "../components/banner"


const Attivita = ({ data, pageContext: { locale } }) => (
  <Layout locale={locale}>
    <SEO title={data.attivita.title} description={data.attivita.abstract} />
    <SpeechDetail intervento={data.attivita} locale={locale} />
    <Programma initialDay={data.attivita.day} />
    {/* <Newsletter /> */}
    {/* <Banner /> */}
  </Layout>
);

export const query = graphql`
  query ActivityQuery($pageslug: String!, $locale: String!) {
    attivita: activityYaml(pageslug: {eq: $pageslug}, lang: {eq: $locale}){
      title
      orario
      orariodesc
      tipologia
      day
      booktitle
      bookabstract
      author
      bio
      imageFile {
        childImageSharp {
          fluid(maxWidth: 260, quality: 100){
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      copertinaImg {
        childImageSharp {
          fluid(maxWidth: 260, quality: 100){
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
`;

export default Attivita;
